import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { InvoiceDetails } from './details';
import { InvoicesOverview } from './overview';
import { InvoiceCreate } from './create';
import { BaseComponent } from '../../../components/BaseComponent';
import { IncomingInvoiceDetails } from './incomingInvoiceDetails';
import { ProductInvoicesOverviewTable } from '../../products/components/ProductInvoicesOverviewTable';
import { ProductInvoice } from '../../products/components/ProductInvoice';
import { ProductInvoiceCreate } from './createProductInvoice';
import { resetInvoiceValues } from '../actions';
import { OutgoingInvoiceDetails } from './outgoingInvoiceDetails';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class InvoicesPageComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    this.props.resetValues();
  }

  render() {
    if (this.props.work) return <Loader small />;
    
    return (
      <Container>
        <Switch>
          <Route
            exact
            path="(.*)/invoices/product-invoices/vehicle/:vehicleId"
            render={component => <ProductInvoicesOverviewTable vehicleId={parseInt(component.match.params.vehicleId, 10)} />}
          />

          <Route
            path="(.*)/invoices/product-invoices/vehicle/:vehicleId/:type/:direction/create"
            render={component => <ProductInvoiceCreate vehicleId={parseInt(component.match.params.vehicleId, 10)} />}
          />

          <Route
            exact
            path="(.*)/invoices/product-invoices/vehicle/:vehicleId/invoice/:invoiceId(.*)"
            render={component => (
              <ProductInvoice
                vehicleId={parseInt(component.match.params.vehicleId, 10)}
                invoiceId={parseInt(component.match.params.invoiceId, 10)}
              />
            )}
          />
          <Route
            exact
            path="(.*)/invoices/product-invoices/invoice/:invoiceId(.*)"
            render={component => <ProductInvoice invoiceId={parseInt(component.match.params.invoiceId, 10)} />}
          />
          <Route exact path="(.*)/invoices/:type/create" render={component => <InvoiceCreate />} />
          <Route path="(.*)/invoices/create" component={InvoiceCreate} />
          <Route path="(.*)/invoices/:type/:direction/create" component={ProductInvoiceCreate} />
          <Route path="(.*)/invoices/:type/:direction/create" component={ProductInvoiceCreate} />
          <Route
            path="(.*)/invoices/:type/:direction/create-copy/:invoiceId"
            render={component => <ProductInvoiceCreate invoiceId={parseInt(component.match.params.invoiceId, 10)} />}
          />
          <Route
            path="(.*)/invoices/:type/:direction/create-copy/:invoiceId"
            render={component => <ProductInvoiceCreate invoiceId={parseInt(component.match.params.invoiceId, 10)} />}
          />
          <Route
            exact
            path="(.*)/invoices/incoming/:id(.*)"
            render={component => <IncomingInvoiceDetails invoice_id={component.match.params.id} />}
          />
          <Route
            path="(.*)/invoices/outgoing/:id(.*)"
            // render={component => <InvoiceDetails invoice_id={component.match.params.id} />}
            render={component => <OutgoingInvoiceDetails invoice_id={component.match.params.id} />}
          />

          <Route
            path="(.*)/invoices/:id(.*)"
            render={component => <InvoiceDetails invoice_id={component.match.params.id} />}
          />
          <Route component={InvoicesOverview} />
        </Switch>
      </Container>
    );
  }
}

InvoicesPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    resetValues() {
      dispatch(resetInvoiceValues());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoicesPage = compose(withConnect, withRouter)(InvoicesPageComp);
